import type { MouseEvent } from "react";

import { callAll } from "../../../../utils/call-all";
import { useSearchMenuContext } from "../../search-menu.context";
import type { SearchMenuItemProps, SearchMenuItemViewProps } from "./types-item";

/** ViewModel do SearchMenu.Item: visibilidade pela busca e clique que seleciona e soma (`callAll`) o `onClick` da tela; sem JSX. */
export function useSearchMenuItem({
  id,
  testId,
  className,
  onClick,
  children,
  ...rest
}: SearchMenuItemProps): SearchMenuItemViewProps {
  const { isVisible, select } = useSearchMenuContext();

  return {
    visible: isVisible(id),
    testId,
    className,
    onClick: callAll((_event: MouseEvent<HTMLButtonElement>) => select(id), onClick),
    rest,
    children,
  };
}
